module.exports = __webpack_public_path__ + "static/img-23-847e574dbcd86b0dcf7280cb66f797df.jpeg";